import {
  BoldItalicUnderlineToggles,
  InsertThematicBreak,
  listsPlugin,
  ListsToggle,
  MDXEditor,
  MDXEditorMethods,
  Separator,
  StrikeThroughSupSubToggles,
  thematicBreakPlugin,
  toolbarPlugin,
  UndoRedo,
} from "@mdxeditor/editor"
import "@mdxeditor/editor/style.css"
import { Paper } from "@mui/material"
import { useEffect, useRef } from "react"

type MarkdownEditorProps = {
  onChangeContent: (content: string) => void
  content: string
}

// Force dark mode regardless of browser settings
const prefersDark = true

export const MarkdownEditor = (props: MarkdownEditorProps) => {
  const { onChangeContent, content } = props
  const ref = useRef<MDXEditorMethods>(null)

  useEffect(() => {
    if (ref.current) {
      ref.current.setMarkdown(content)
    }
  }, [content])

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2 }}>
      <MDXEditor
        ref={ref}
        markdown={content}
        className={prefersDark ? "dark-theme dark-editor" : "markdown-editor"}
        plugins={[
          listsPlugin(),
          thematicBreakPlugin(),
          toolbarPlugin({
            toolbarContents: () => (
              <>
                <UndoRedo />
                <Separator />
                <BoldItalicUnderlineToggles />
                <Separator />
                <StrikeThroughSupSubToggles />
                <Separator />
                <ListsToggle />
                <Separator />
                <InsertThematicBreak />
              </>
            ),
          }),
        ]}
        onChange={(content: string) => {
          onChangeContent(content)
        }}
      />
    </Paper>
  )
}
